import { render, staticRenderFns } from "./FormToggleInput.vue?vue&type=template&id=2c0bdad2"
import script from "./FormToggleInput.vue?vue&type=script&lang=js"
export * from "./FormToggleInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports